import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { LogToastService } from 'src/app/shared/services/log-toast/log-toast.service';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  #api = inject(ApiService);
  #logToast = inject(LogToastService);

  async resetPassword(token: string, password: string, loginType: string): Promise<boolean> {
    try {
      await this.#api.resetPasswordWithToken(token, password);
      this.#logToast.success(
        'MESSAGES.SUCCESS.SUCCESSFULLY_UPDATE_LOGIN_TYPE',
        { loginType },
        { logger: false, toast: true },
      );
      return true;
    } catch (error) {
      this.#logToast.error('MESSAGES.ERRORS.FAILED_TO_SEND_RESET_PASSWORD_INSTRUCTIONS', error);
      return false;
    }
  }
}
